export const PREDEFINED_ROLES = ["owner", "admin", "user"];

export const PERMISSIONS = {
  ACCESS_TO_COMPANY_PAGE: "Access to company page",
  ACCESS_TO_BILLING_PAGE: "Access to billing page",
  ACCESS_TO_USERS_PAGE: "Access to users page",
  ACCESS_TO_SUBSCRIPTIONS_PAGE: "Access to subscriptions page",
  ACCESS_TO_ROLES_AND_PERMISSIONS_PAGE: "Access to roles and permissions page",
  ACCESS_TO_WORKFLOWS_PAGE: "Access to workflows page",
  ACCESS_TO_DESIGNER: "Access to designer",
  ACCESS_TO_CUSTOMER_SUBSCRIPTIONS_PAGE: "Access to customer subscriptions page",
  EDIT_USERS: "Edit users",
  ACCESS_TO_ACCOUNT_SETTINGS: "Access to account settings",
  ACCESS_TO_CONNECTOR_APPROVAL_PAGE: "Access to connector approval page",
  REMOVE_CREDIT_CARD: "Remove credit card",
  UPDATE_BILLING_INFO: "Update billing info",
  ADD_CREDIT_CARD: "Add credit card",
  MANAGE_COMPANY_PROFILE: "Manage company profile",
  ACCESS_TO_COMPANY_EDIT_PAGE: "Access to company edit page",
  CREATE_WORKFLOWS: "Create workflows",
  SHARE_WORKFLOWS: "Share workflows",
  EDIT_WORKFLOWS: "Edit workflows",
  RETRIEVE_WORKFLOWS: "Retrieve workflows",
  DEACTIVATE_WORKFLOWS: "Deactivate workflows",
  DELETE_WORKFLOWS: "Delete workflows",
  ACTIVATE_WORKFLOWS: "Activate workflows",
  DEACTIVATE_OWN_ACCOUNT: "Deactivate own account",
  DELETE_OWN_ACCOUNT: "Delete own account",
  REMOVE_ROLES: "Remove roles",
  CREATE_ROLES: "Create roles",
  EDIT_ROLES: "Edit roles",
  MANAGE_SUBSCRIPTION: "Manage subscription",
  REMOVE_USERS: "Remove users",
  RESTORE_USERS: "Restore users",
  INVITE_USERS: "Invite users",
  ASSIGN_ROLE: "Assign role",
  TRANSFER_OWNERSHIP: "Transfer ownership",
  APPROVE_PUBLISH_CONNECTOR: "Approve publish connector",
  CREATE_SUPPORT_TICKET: "Create support ticket",
  ACCESS_TO_ACCOUNT_PAGE: "Access to account page",
  ACCESS_TO_QUICK_START_PAGE: "Access to quick start page",
  SUSPEND_USERS: "Suspend users",
  UNSUSPEND_USERS: "Unsuspend users",
  CREATE_CREDENTIALS: "Create credentials",
  MODIFY_CREDENTIALS: "Modify credentials",
  VIEW_CREDENTIALS: "View credentials",
  SHARE_CREDENTIALS: "Share credentials",
  DELETE_CREDENTIALS: "Delete credentials",
  ACCESS_TO_CREDENTIAL_MANAGEMENT_PAGE: "Access to credential management page",
  ACCESS_TO_CONNECTORS_PAGE: "Access to connectors page",
  CREATE_CONNECTORS: "Create connectors",
  EDIT_CONNECTORS: "Edit connectors",
  DELETE_CONNECTORS: "Delete connectors",
  SHARE_CONNECTORS: "Share connectors",
  ACCESS_TO_LOGS_PAGE: "Access to logs page",
  ACCESS_TO_SCHEDULER_PAGE: "Access to scheduler page",
  ADD_SCHEDULES: "Add schedules",
  EDIT_SCHEDULES: "Edit schedules",
  DELETE_SCHEDULES: "Delete schedules",
  PAUSE_SCHEDULES: "Pause schedules",
  PUBLISH_FLOW: "Publish flow",
  VIEW_ANY_WORKFLOWS: "View any workflows",
  EDIT_ANY_WORKFLOWS: "Edit any workflows",
  DELETE_ANY_WORKFLOWS: "Delete any workflows",
  SHARE_ANY_WORKFLOWS: "Share any workflows",
  VIEW_ANY_INTEGRATIONS: "View any integrations",
  EDIT_ANY_INTEGRATIONS: "Edit any integrations",
  DELETE_ANY_INTEGRATIONS: "Delete any integrations",
  SHARE_ANY_INTEGRATIONS: "Share any integrations",
  VIEW_ANY_CONNECTORS: "View any connectors",
  EDIT_ANY_CONNECTORS: "Edit any connectors",
  DELETE_ANY_CONNECTORS: "Delete any connectors",
  SHARE_ANY_CONNECTORS: "Share any connectors",
  VIEW_ANY_CREDENTIALS: "View any credentials",
  EDIT_ANY_CREDENTIALS: "Edit any credentials",
  DELETE_ANY_CREDENTIALS: "Delete any credentials",
  SHARE_ANY_CREDENTIALS: "Share any credentials",
  VIEW_ANY_SCHEDULES: "View any schedules",
  EDIT_ANY_SCHEDULES: "Edit any schedules",
  DELETE_ANY_SCHEDULES: "Delete any schedules",
  SHARE_ANY_SCHEDULES: "Share any schedules",
  DELETE_COMPANY_ACCOUNT: "Delete company account",
  DEACTIVATE_COMPANY_ACCOUNT: "Deactivate company account",
  UNREGISTER_COMPONENT: "Unregister component",
  UNPUBLISH_FLOW: "Unpublish flow",
  PUBLISH_AND_UNPUBLISH_COMPONENTS: "Publish and unpublish components",
  REGISTER_COMPONENTS: "Register components",
  PURCHASE_COMPONENTS: "Purchase components",
  VIEW_TICKETS: "View tickets",
  APPROVE_PUBLISHED_CONNECTOR: "Approve published connector"
};

export const ACCESS_TYPE_OPTIONS = [
  { value: "readOnly", label: "Read Only" },
  { value: "editor", label: "Editor" }
];

export const LOGO_SIZE_ERROR_MESSAGE = "File is too large. Max size is 5MB";
